export default class UserType {}

UserType.Partner = 'PARTNER';
UserType.Client = 'CLIENT';
